import {Transition, TransitionData} from "./transition";
import {Marshal, MarshalData} from "./marshal";

export interface IStateMeta {
    type: "jump" | "default"
    blockNames?: string[]
    position?: { x: number, y: number }
    depth?: number
}
export interface StateData {
    actions: MarshalData[]
    child?: string
    meta?: IStateMeta
    name: string
    parent?: string
    script: string
    summary?: string
    transitions: TransitionData[]
}

export class State {
    public readonly child: string;
    public readonly actions: Array<Marshal>;
    public readonly transitions: Array<Transition>;
    public readonly parent: string;
    public readonly meta: IStateMeta
    public readonly name: string;
    public readonly script: string;
    public readonly summary: string;

    constructor(data: StateData) {
        this.actions = (data.actions || []).map(data => new Marshal(data));
        this.child = data.child || '';
        this.meta = data.meta || {type: "default"};
        this.name = data.name || '';
        this.parent = data.parent || '';
        this.script = data.script || '';
        this.summary = data.summary || '';
        this.transitions = (data.transitions || []).map(transition => new Transition(transition));
    }

    getTransition(trigger: string): Transition | undefined {
        if (trigger === 'continue' && this.transitions?.length === 1) {
            return this.transitions[0];
        } else {
            return this.transitions.find(transition => transition.trigger === trigger);
        }
    }
    public serialise(): StateData {
        return {
            actions: this.actions.map(action => action.serialise()),
            child: this.child || '',
            name: this.name || '',
            parent: this.parent,
            script: this.script || '',
            summary: this.summary || '',
            transitions: this.transitions.map(transition => transition.serialise())
        };
    }
}
